import { rt } from '../player/runtime';

/** flash.ui.Keyboard key codes (Flash Player / Windows virtual key codes). */
export const Keyboard: Record<string, number> = (() => {
  const k: Record<string, number> = {
    BACKSPACE: 8,
    TAB: 9,
    ENTER: 13,
    COMMAND: 15,
    SHIFT: 16,
    CONTROL: 17,
    ALTERNATE: 18,
    BREAK: 19,
    CAPS_LOCK: 20,
    NUMPAD: 21,
    ESCAPE: 27,
    SPACE: 32,
    PAGE_UP: 33,
    PAGE_DOWN: 34,
    END: 35,
    HOME: 36,
    LEFT: 37,
    UP: 38,
    RIGHT: 39,
    DOWN: 40,
    INSERT: 45,
    DELETE: 46,
    NUMPAD_MULTIPLY: 106,
    NUMPAD_ADD: 107,
    NUMPAD_ENTER: 108,
    NUMPAD_SUBTRACT: 109,
    NUMPAD_DECIMAL: 110,
    NUMPAD_DIVIDE: 111,
    SEMICOLON: 186,
    EQUAL: 187,
    COMMA: 188,
    MINUS: 189,
    PERIOD: 190,
    SLASH: 191,
    BACKQUOTE: 192,
    LEFTBRACKET: 219,
    BACKSLASH: 220,
    RIGHTBRACKET: 221,
    QUOTE: 222,
  };
  for (let i = 0; i < 26; i++) k[String.fromCharCode(65 + i)] = 65 + i;
  for (let i = 0; i <= 9; i++) {
    k['NUMBER_' + i] = 48 + i;
    k['NUMPAD_' + i] = 96 + i;
  }
  for (let i = 1; i <= 15; i++) k['F' + i] = 111 + i;
  return k;
})();

/** Keyboard.capsLock / numLock equivalents (not tracked headless). */
export const KeyboardState = { capsLock: false, numLock: false };

export const KeyLocation = { STANDARD: 0, LEFT: 1, RIGHT: 2, NUM_PAD: 3 } as const;

/** flash.ui.Mouse: cursor visibility / style exposed to the host through the runtime. */
export const Mouse: { hide(): void; show(): void; cursor: string; readonly supportsCursor: boolean } = {
  hide(): void {
    rt().mouseHidden = true;
  },
  show(): void {
    rt().mouseHidden = false;
  },
  get cursor(): string {
    return rt().mouseCursor;
  },
  set cursor(v: string) {
    rt().mouseCursor = String(v);
  },
  get supportsCursor(): boolean {
    return true;
  },
};

export const MouseCursor = { ARROW: 'arrow', AUTO: 'auto', BUTTON: 'button', HAND: 'hand', IBEAM: 'ibeam' } as const;
